// extracted by mini-css-extract-plugin
export default {"container":"player_container__gqZhl"};